import { render } from "./walletConnect.vue?vue&type=template&id=cdc064bc"
import script from "./walletConnect.vue?vue&type=script&lang=js"
export * from "./walletConnect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\icflip-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__